import { SignupPayload } from '../../Views/Blocks/SignupBlock/classes/SignupPayload';

export interface Tracker {
  fireSignupSuccess(signupData: SignupPayload, teamSize: number): Promise<void>;
  fireSignupStep(step: number): Promise<void>;
  fireMarketingAutomationSubmission(
    type: MarketingAutomationSubmissionType,
  ): Promise<void>;
}

export const MarketingAutomationSubmissionType = {
  MarketoForm: 'Marketo',
  ChiliPiperConcierge: 'Chili Piper Concierge',
} as const satisfies Record<string, string>;

export type MarketingAutomationSubmissionType =
  (typeof MarketingAutomationSubmissionType)[keyof typeof MarketingAutomationSubmissionType];
